export var isException = function isException(result) {
  return result.exception !== undefined;
};
export var isError = function isError(result) {
  return result.error !== undefined;
};
export var isSuccessful = function isSuccessful(result) {
  return result.payload !== undefined;
};
export var isFailure = function isFailure(result) {
  return result.payload === undefined;
};
export var createErrorResult = function createErrorResult(error) {
  return {
    error: error,
    payload: undefined,
    exception: undefined
  };
};
export var createSuccessResult = function createSuccessResult(payload) {
  return {
    payload: payload,
    error: undefined,
    exception: undefined
  };
};
export var createExceptionResult = function createExceptionResult(exception) {
  return {
    payload: undefined,
    error: undefined,
    exception: exception
  };
};